import React, { useState } from "react";
import { Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomTextField from "../../components/Custom/CustomTextField";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { FpoFarmerProfileValidationSchema } from "../../components/Custom/ValidationSchema";
const validationSchema = FpoFarmerProfileValidationSchema();

export default function AddFPOFarmerNew() {
  const [profileData, setProfileData] = useState({});
  const navigate = useNavigate();
  const { errors, validate } = useFormValidation(profileData, validationSchema);
  const { t } = useTranslation();

  const handleChange = (name, value) => {
    setProfileData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...profileData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    validate(profileData);
    if (Object.keys(errors).length === 0) {
      profileData.designation = "FARMER";

      api
        .post("/fpo/add-fpo-farmer/", profileData)
        .then((response) => {
          alert(response.data.message);
          // window.location.href = "/fpo/farmers";
          navigate("/fpo/farmers");
        })
        .catch((error) => {
          console.error("Error making POST request:", error);
        });
    } else {
      alert("Please fix the validation errors before submitting.");
    }
  };

  const fields = [
    { label: t("Name"), name: "full_name" },
    { label: "Mobile", name: "mobile", type: "tel" },
    { label: t("Address"), name: "address" },
    { label: t("Aadhar Number"), name: "aadhar_number" },
    { label: t("PAN Number"), name: "pan_number" },
    {
      label: t("Farming Since Year"),
      name: "farming_since_year",
      type: "number",
    },
    { label: t("Crops Covered"), name: "crops_covered" },
  ];
  return (
    <>
      <CustomAppBar title="Add Farmer" />
      <Container maxWidth="xs">
        <Grid
          container
          // spacing={1}
          justify="center"
          direction="column"
          style={{ marginTop: "10px" }}
        >
          <Box>
            <Box component="form" sx={{ mt: 3 }}>
              {fields.map((field, index) => (
                <CustomTextField
                  key={index}
                  label={field.label}
                  name={field.name}
                  type={field.type}
                  value={profileData[field.name] || ""}
                  onChange={handleChange}
                  error={errors[field.name]}
                  helperText={errors[field.name]}
                />
              ))}
            </Box>
            <CustomButton onClick={handleSubmit}>{t("Save")}</CustomButton>
          </Box>
        </Grid>
      </Container>
    </>
  );
}
